// extracted by mini-css-extract-plugin
module.exports = {"btn":"Toolbutton_btn__1gW_r","btnSelected":"Toolbutton_btnSelected__ZgLuZ"};